<template>
  <div class="jim-scheduling-container footage-page">

    <div class="page-header-row">
      <div class="page-header-left"></div>
      <h1 class="page-heading">MONTHLY FOOTAGE SHIPPED YOY BY PLANT</h1>
      <div class="page-header-right"></div>
    </div>

    <div class="main-content">
      <!-- LEFT CONTROLS -->
      <div class="left-side-section">

        <div class="control" style="width:100%;">
          <label>Start Date</label>
          <input v-model="startDate" type="date" />
        </div>

        <div class="control" style="width:100%;">
          <label>End Date</label>
          <input v-model="endDate" type="date" />
        </div>

        <button class="plan-it-btn" :disabled="loading || !canRun" @click="runReport">
          {{ loading ? "Loading..." : "Run Report" }}
        </button>

        <button class="plan-it-btn" :disabled="!report" @click="exportCSV">
          Export CSV
        </button>

        <button class="plan-it-btn" :disabled="!report" @click="openPrint">
          Print PDF
        </button>

      </div>

      <!-- RIGHT CONTENT -->
      <div class="right-side-section">

        <div v-if="report" class="summary-bar">
          <div class="summary-item">
            <div class="summary-label">Period</div>
            <div class="summary-value">{{ rangeLabelCY }}</div>
          </div>

          <div class="summary-item">
            <div class="summary-label">Compared To</div>
            <div class="summary-value">{{ rangeLabelLY }}</div>
          </div>
        </div>

        <div v-if="report" class="sheet-scroll-container">
          <div class="panel report-panel">

            <div class="table-scroll">
              <table class="footage-table">
                <thead>
                  <tr>
                    <th class="sticky-col month-col">Month</th>

                    <th colspan="3">Fresno</th>
                    <th colspan="3">Denver</th>
                    <th colspan="3">Knoxville</th>
                    <th colspan="3">Lakeland</th>
                    <th colspan="3">Combined</th>
                  </tr>

                  <!-- STEP 6 UPDATE: MAKE IT EXPLICIT -->
                  <tr>
                    <th class="sticky-col month-col"></th>

                    <th class="num-col">LY</th>
                    <th class="num-col">CY</th>
                    <th class="pct-col">%</th>

                    <th class="num-col">LY</th>
                    <th class="num-col">CY</th>
                    <th class="pct-col">%</th>

                    <th class="num-col">LY</th>
                    <th class="num-col">CY</th>
                    <th class="pct-col">%</th>

                    <th class="num-col">LY</th>
                    <th class="num-col">CY</th>
                    <th class="pct-col">%</th>

                    <th class="num-col">LY</th>
                    <th class="num-col">CY</th>
                    <th class="pct-col">%</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="m in report.months" :key="m.month">
                    <td class="sticky-col month-col">{{ m.label }}</td>

                    <td class="clickable" @click="openDrill('LY', m.month, 'F')">{{ fmtInt(m.plants.F.y1) }}</td>
                    <td class="clickable" @click="openDrill('CY', m.month, 'F')">{{ fmtInt(m.plants.F.y2) }}</td>
                    <td>{{ fmtPct(m.plants.F.pct) }}</td>

                    <td class="clickable" @click="openDrill('LY', m.month, 'D')">{{ fmtInt(m.plants.D.y1) }}</td>
                    <td class="clickable" @click="openDrill('CY', m.month, 'D')">{{ fmtInt(m.plants.D.y2) }}</td>
                    <td>{{ fmtPct(m.plants.D.pct) }}</td>

                    <td class="clickable" @click="openDrill('LY', m.month, 'K')">{{ fmtInt(m.plants.K.y1) }}</td>
                    <td class="clickable" @click="openDrill('CY', m.month, 'K')">{{ fmtInt(m.plants.K.y2) }}</td>
                    <td>{{ fmtPct(m.plants.K.pct) }}</td>

                    <td class="clickable" @click="openDrill('LY', m.month, 'L')">{{ fmtInt(m.plants.L.y1) }}</td>
                    <td class="clickable" @click="openDrill('CY', m.month, 'L')">{{ fmtInt(m.plants.L.y2) }}</td>
                    <td>{{ fmtPct(m.plants.L.pct) }}</td>

                    <td class="clickable" @click="openDrill('LY', m.month, 'ALL')">{{ fmtInt(m.combined.y1) }}</td>
                    <td class="clickable" @click="openDrill('CY', m.month, 'ALL')">{{ fmtInt(m.combined.y2) }}</td>
                    <td>{{ fmtPct(m.combined.pct) }}</td>
                  </tr>

                  <tr class="totals-row">
                    <td class="sticky-col month-col">TOTALS:</td>

                    <td>{{ fmtInt(report.totals.plants.F.y1) }}</td>
                    <td>{{ fmtInt(report.totals.plants.F.y2) }}</td>
                    <td>{{ fmtPct(report.totals.plants.F.pct) }}</td>

                    <td>{{ fmtInt(report.totals.plants.D.y1) }}</td>
                    <td>{{ fmtInt(report.totals.plants.D.y2) }}</td>
                    <td>{{ fmtPct(report.totals.plants.D.pct) }}</td>

                    <td>{{ fmtInt(report.totals.plants.K.y1) }}</td>
                    <td>{{ fmtInt(report.totals.plants.K.y2) }}</td>
                    <td>{{ fmtPct(report.totals.plants.K.pct) }}</td>

                    <td>{{ fmtInt(report.totals.plants.L.y1) }}</td>
                    <td>{{ fmtInt(report.totals.plants.L.y2) }}</td>
                    <td>{{ fmtPct(report.totals.plants.L.pct) }}</td>

                    <td>{{ fmtInt(report.totals.combined.y1) }}</td>
                    <td>{{ fmtInt(report.totals.combined.y2) }}</td>
                    <td>{{ fmtPct(report.totals.combined.pct) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>

        <div v-else class="panel hint-panel">
          Select dates, then click <b>Run Report</b>.
        </div>

      </div>
    </div>

    <!-- DRILLDOWN MODAL -->
    <div v-if="drillOpen" class="modal-overlay" @click.self="closeDrill">
      <div class="modal panel">
        <div class="modal-header">
          <div class="modal-title">
            Drilldown: {{ drillTitle }}
          </div>
          <button class="modal-close" @click="closeDrill">✕</button>
        </div>

        <div v-if="drillLoading" class="panel" style="margin-top:10px;">
          Loading drilldown...
        </div>

        <div v-else-if="drillError" class="panel error-box" style="margin-top:10px;">
          {{ drillError }}
        </div>

        <div v-else-if="drillData" style="margin-top:10px;">
          <div class="panel" style="margin-bottom:10px;">
            <div class="warn-title">Top Items</div>
            <div class="table-scroll">
              <table class="mini-table">
                <thead>
                  <tr><th>Item</th><th style="text-align:right;">Footage</th></tr>
                </thead>
                <tbody>
                  <tr v-for="x in (drillData.top_items || [])" :key="x.item_no">
                    <td>{{ x.item_no }}</td>
                    <td style="text-align:right;">{{ fmtInt(x.footage) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="panel">
            <div class="warn-title">Rows ({{ drillData.rows?.length || 0 }})</div>
            <div class="table-scroll">
              <table class="mini-table">
                <thead>
                  <tr>
                    <th style="width:110px;">Date</th>
                    <th>Plant</th>
                    <th>Item</th>
                    <th style="text-align:right;">Qty</th>
                    <th style="text-align:right;">Ft/Unit</th>
                    <th style="text-align:right;">Footage</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(r, idx) in drillData.rows" :key="idx">
                    <td>{{ fmtDate(r.billed_dt) }}</td>
                    <td>{{ r.plant }}</td>
                    <td>{{ r.item_no }}</td>
                    <td style="text-align:right;">{{ fmtNum(r.qty_to_ship) }}</td>
                    <td style="text-align:right;">{{ fmtNum(r.ft_per) }}</td>
                    <td style="text-align:right;">{{ fmtNum(r.footage) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>

      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "FootageShippedYoYPage",

  data() {
    const now = new Date();
    const y2 = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    return {
      startDate: `${y2}-01-01`,
      endDate: `${y2}-${mm}-${dd}`,

      loading: false,
      report: null,

      drillOpen: false,
      drillLoading: false,
      drillError: null,
      drillData: null,
      drillParams: { period: null, month: null, plant: null, startDate: null, endDate: null }
    };
  },

  computed: {
    canRun() {
      if (!this.startDate || !this.endDate) return false;
      const s = new Date(this.startDate);
      const e = new Date(this.endDate);
      return !isNaN(s.getTime()) && !isNaN(e.getTime()) && s <= e;
    },
    drillTitle() {
      if (!this.drillParams.period) return "";

      const mo = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"][this.drillParams.month - 1] || "";
      const plantName = this.plantLabel(this.drillParams.plant);

      const baseYear = this.drillParams.startDate
        ? Number(String(this.drillParams.startDate).slice(0, 4))
        : "";

      const yy = (this.drillParams.period === "LY" && Number.isFinite(baseYear))
        ? baseYear - 1
        : baseYear;

      return `${plantName} • ${mo} ${yy} • ${this.drillParams.period}`;
    },
    rangeLabelCY() {
      if (!this.startDate || !this.endDate) return "";
      return `${this.startDate} → ${this.endDate}`;
    },
    rangeLabelLY() {
      const r = this.getPriorYearRange(this.startDate, this.endDate);
      if (!r) return "";
      return `${r.start} → ${r.end}`;
    },
  },

  methods: {
    plantLabel(p) {
      if (p === "F") return "Fresno";
      if (p === "D") return "Denver";
      if (p === "K") return "Knoxville";
      if (p === "L") return "Lakeland";
      return "Combined";
    },

    toISODate(d) {
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    },

    getPriorYearRange(startISO, endISO) {
      if (!startISO || !endISO) return null;

      const pad = (n) => String(n).padStart(2, "0");

      const [sy, sm, sd] = startISO.split("-").map(Number);
      const [ey, em, ed] = endISO.split("-").map(Number);

      return {
        start: `${sy - 1}-${pad(sm)}-${pad(sd)}`,
        end:   `${ey - 1}-${pad(em)}-${pad(ed)}`
      };
    },

    async runReport() {
      if (this.loading) return;
      this.loading = true;
      this.report = null;

      try {
        const ly = this.getPriorYearRange(this.startDate, this.endDate);

        const { data } = await axios.get("/footageShippedYoY", {
          params: {
            startDate: this.startDate,
            endDate: this.endDate,
            priorStartDate: ly?.start,
            priorEndDate: ly?.end
          }
        });
        this.report = data;
      } catch (err) {
        console.error(err);
        alert(err?.response?.data?.error || "Failed to load report.");
      } finally {
        this.loading = false;
      }
    },

    async openDrill(period, month, plant) {
      this.drillOpen = true;
      this.drillLoading = true;
      this.drillError = null;
      this.drillData = null;

      // store for title
      this.drillParams = { period, month, plant };

      try {
        const { data } = await axios.get("/footageShippedYoYDrilldown", {
          params: {
            startDate: this.startDate,
            endDate: this.endDate,
            month,
            plant,
            period,      // 'LY' or 'CY'
            limit: 500
          }
        });
        this.drillData = data;
      } catch (err) {
        console.error(err);
        this.drillError = err?.response?.data?.error || "Failed to load drilldown.";
      } finally {
        this.drillLoading = false;
      }
    },

    closeDrill() {
      this.drillOpen = false;
      this.drillLoading = false;
      this.drillError = null;
      this.drillData = null;
      this.drillParams = { period: null, month: null, plant: null, startDate: null, endDate: null };
    },

    fmtInt(v) {
      const n = Number(v || 0);
      return n.toLocaleString("en-US", { maximumFractionDigits: 0 });
    },
    fmtNum(v) {
      const n = Number(v || 0);
      return n.toLocaleString("en-US", { maximumFractionDigits: 2 });
    },
    fmtPct(v) {
      if (v == null) return "-";
      return `${Number(v).toFixed(0)}%`;
    },
    fmtDate(v) {
      if (!v) return "";
      const d = new Date(v);
      if (isNaN(d.getTime())) return String(v);
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const yyyy = d.getFullYear();
      return `${mm}/${dd}/${yyyy}`;
    },

    openPrint() {
      if (!this.startDate || !this.endDate) return;

      const params = new URLSearchParams();
      params.set("startDate", this.startDate);
      params.set("endDate", this.endDate);

      const url = `/footage-shipped-yoy/print?${params.toString()}`;
      window.open(url, "_blank");
    },

    exportCSV() {
      if (!this.report) return;

      const rows = [];
      const rangeLY = this.report.rangeLY || this.rangeLabelLY;
      const rangeCY = this.report.rangeCY || this.rangeLabelCY;

      rows.push([
        "Month",
        `Fresno Prior Year (${rangeLY})`, `Fresno Selected (${rangeCY})`, "Fresno %",
        `Denver Prior Year (${rangeLY})`, `Denver Selected (${rangeCY})`, "Denver %",
        `Knoxville Prior Year (${rangeLY})`, `Knoxville Selected (${rangeCY})`, "Knoxville %",
        `Lakeland Prior Year (${rangeLY})`, `Lakeland Selected (${rangeCY})`, "Lakeland %",
        `Combined Prior Year (${rangeLY})`, `Combined Selected (${rangeCY})`, "Combined %"
      ]);

      for (const m of this.report.months) {
        rows.push([
          m.label,
          m.plants.F.y1, m.plants.F.y2, m.plants.F.pct ?? "",
          m.plants.D.y1, m.plants.D.y2, m.plants.D.pct ?? "",
          m.plants.K.y1, m.plants.K.y2, m.plants.K.pct ?? "",
          m.plants.L.y1, m.plants.L.y2, m.plants.L.pct ?? "",
          m.combined.y1, m.combined.y2, m.combined.pct ?? ""
        ]);
      }

      rows.push([
        "TOTALS",
        this.report.totals.plants.F.y1, this.report.totals.plants.F.y2, this.report.totals.plants.F.pct ?? "",
        this.report.totals.plants.D.y1, this.report.totals.plants.D.y2, this.report.totals.plants.D.pct ?? "",
        this.report.totals.plants.K.y1, this.report.totals.plants.K.y2, this.report.totals.plants.K.pct ?? "",
        this.report.totals.plants.L.y1, this.report.totals.plants.L.y2, this.report.totals.plants.L.pct ?? "",
        this.report.totals.combined.y1, this.report.totals.combined.y2, this.report.totals.combined.pct ?? ""
      ]);

      const csv = rows
        .map(r => r.map(val => `"${String(val).replace(/"/g, '""')}"`).join(","))
        .join("\n");

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      // filename based on selected range
      const safeStart = String(this.startDate || "").replaceAll("-", "");
      const safeEnd = String(this.endDate || "").replaceAll("-", "");
      link.setAttribute("download", `monthly_footage_shipped_yoy_${safeStart}_${safeEnd}.csv`);

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  }
};
</script>

<style scoped>
/* reuse your P&L styles with minimal additions */
.footage-page {
  background-color: #0b0101;
  min-height: 100vh;
  padding: 14px;
}

.jim-scheduling-container {
  font-family: Garamond, serif;
  color: #cbbfbf;
  display: flex;
  flex-direction: column;
  background-color: #0b0101;
  min-height: 100vh;
}

.page-header-row {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  margin-bottom: 10px;
}

.page-heading {
  font-family: 'Cormorant Garamond', serif;
  font-size: 30px;
  color: #cbbfbf;
  margin: 0;
  text-align: center;
}

.main-content {
  display: grid;
  grid-template-columns: 200px 1fr;
  gap: 12px;
  width: 100%;
  padding: 0 14px;
  box-sizing: border-box;
  align-items: start;
}

.left-side-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-top: 120px;
}

.right-side-section { width: 100%; min-width: 0; }

.sheet-scroll-container {
  max-height: 80vh;
  overflow-y: auto;
  width: 100%;
  border-radius: 10px;
  padding-right: 10px;
  box-sizing: border-box;
}

.panel {
  background-color: #0b0101;
  border: 1px solid #888;
  border-radius: 10px;
  padding: 10px 12px;
  text-align: left;
}

.report-panel {
  background-color: #708090a4;
  border-radius: 10px;
  border: 1px solid #888;
}

.control { display:flex; flex-direction:column; gap:6px; width:100%; }
.control label { font-size: 13px; font-weight: 600; }
.control input {
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #444;
  background-color: #111;
  color: #cbbfbf;
  font-family: inherit;
  width: 100%;
  box-sizing: border-box;
}

.plan-it-btn {
  border-radius: 10px;
  padding: 8px 16px;
  width: 160px;
  background-color: #f3f4f6;
  border: 1px solid #cfd3d8;
  color: #333;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  height: 38px;
}
.plan-it-btn:disabled { background-color: #e5e7eb; color:#888; cursor:not-allowed; }

.summary-bar {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid #888;
  margin: 0 0 12px;
  background-color: #708090a4;
  flex-wrap: wrap;
}

.summary-item { min-width: 140px; flex: 1 1 140px; display:flex; flex-direction:column; align-items:center; }
.summary-label { font-size: 18px; opacity: 0.85; }
.summary-value { font-size: 18px; font-weight: bold; color: #fff; }

.table-scroll { overflow-x:auto; padding-bottom: 6px; }

.footage-table { width: 100%; border-collapse: collapse; min-width: 1250px; }
.footage-table th, .footage-table td {
  border: 1px solid #333;
  padding: 6px 8px;
  font-size: 13px;
  text-align: right;
  white-space: nowrap;
}
.footage-table th {
  background-color: #0b0101;
  color: #cbbfbf;
  font-weight: bold;
  position: sticky;
  top: 0;
  z-index: 3;
}

.sticky-col {
  position: sticky;
  left: 0;
  z-index: 4;
  background: #0b0101;
  color: #cbbfbf;
  text-align: left !important;
}

.month-col { min-width: 90px; }
.num-col { min-width: 120px; }
.pct-col { min-width: 60px; }

.clickable { cursor: pointer; }
.footage-table tbody tr:hover td { background-color: #5595b7c2; color:#fff; }

.totals-row td {
  font-weight: bold;
  border-top: 3px double #cbbfbf !important;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 14px;
}

.modal {
  width: min(1200px, 96vw);
  max-height: 92vh;
  overflow: auto;
  border-radius: 12px;
}

.modal-header { display:flex; align-items:center; justify-content:space-between; gap: 12px; }
.modal-title { font-size: 18px; font-weight: bold; }

.modal-close {
  border: 1px solid #888;
  background: #111;
  color: #cbbfbf;
  border-radius: 8px;
  padding: 6px 10px;
  cursor: pointer;
}

.mini-table { width: 100%; border-collapse: collapse; min-width: 900px; }
.mini-table th, .mini-table td { border: 1px solid #333; padding: 6px 8px; font-size: 13px; }
.mini-table th { background-color: #0b0101; color: #cbbfbf; position: sticky; top: 0; }

.hint-panel { margin-top: 20px; background-color: #0b0101; }
.error-box { border-color: #aa4444; background: #2a0b0b; color: #fca5a5; }
.warn-title { font-weight: bold; margin-bottom: 6px; }
</style>